import JoinCalss from './app.vue'

function install(Vue) {
  function dialog(options = {}) {
    return new Promise((resolve, reject) => {
      const constructor = Vue.extend(JoinCalss)
      const JoinCalssDia = new constructor({
        el: document.createElement('div')
      })
      for (let key in options) {
        JoinCalssDia[key] = options[key]
      }
      JoinCalssDia.resolve = resolve
      JoinCalssDia.reject = reject
      document.body.appendChild(JoinCalssDia.$el)
    })
  }
  Vue.prototype.$checkLocalTime = dialog
}
export default {
  install
}



// WEBPACK FOOTER //
// ./src/components/Stu/checkLocalTime/index.js